//
//
//
//
//
//
//
//
//
//
//

import { roterPre } from '@/settings';
export default {
  name: 'InfoForm',
  props: {
    value: {
      default: undefined,
      type: String
    },
    title: {
      default: undefined,
      type: String
    }
  },
  data: function data() {
    return {};
  },
  methods: {
    goUrl: function goUrl() {
      this.$router.push({
        path: "".concat(roterPre, "/business/holidayType/index"),
        query: {}
      });
    }
  }
};